export const mockSimpleAccount = {
  '553': {
    ID: 553,
    AccountID: 432,
    Name: 'Fanase',
    Login: 'fanase3347@ukbob.com',
    Phone: '70000000000'
  }
};
